import React, { Component } from 'react';
import { Button, Col, Form, Row } from 'antd';
import { Link } from 'react-router';
import '../expenses.less';
import { connect } from 'react-redux';
import { setBackInfo } from '@store/modules/back_info';
import { queryRecoupMyList } from '@api/finance/recoup';
import FormSearch from '../FormSearch';
import TableExpenses from './TableExpenses';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
        loading: false,
      },
    };
  }

  componentWillMount() {
    this.type = '0';
  }

  componentDidMount() {
    this.searchCondition = {};
    const { backInfo } = this.props;
    if (backInfo.path === this.props.route.path) {
      backInfo.start && backInfo.limit && (this.current = backInfo.start);
      backInfo.start &&
        backInfo.limit &&
        (this.pagination = {
          limit: backInfo.limit,
          start: backInfo.start,
        });

      backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
      backInfo.condition && (this.searchCondition.condition = backInfo.condition);
      backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
    }
    this.loadData();
  }

  componentWillUnmount() {
    const params = {
      path: this.props.route.path,
      ...this.searchCondition,
      ...this.pagination,
    };
    this.props.dispatch(setBackInfo(params));
  }

  setTableData = res => {
    this.setState({
      dataSource: {
        list: res.data,
        pagination: {
          total: res.totalSize,
          pageSize: 15,
          current: this.current,
        },
      },
    });
  };

  handleTableChange = pagination => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
    };
    this.current = pagination.current;
    this.loadData();
  };

  handleSearch = params => {
    this.searchCondition = {
      ...params,
    };
    this.current = 1;
    this.pagination = {
      start: 1,
    };
    this.loadData();
  };

  handleChange = val => {
    this.type = val;
    this.current = 1;
    this.pagination = {
      start: 1,
    };
    this.loadData();
  };

  getRecoupMyList = params => {
    this.setState({ loading: true });
    queryRecoupMyList(params).then(res => {
      if (res.statusCode === 200) {
        this.setTableData(res);
      }
      this.setState({ loading: false });
    });
  };

  loadData = () => {
    const params = {
      ...this.searchCondition,
      ...this.pagination,
    };
    this.getRecoupMyList(params);
  };

  render() {
    const { dataSource, loading } = this.state;
    const parentProps = {
      dataSource,
      type: 'mine',
      loading,
      onChange: this.handleTableChange,
    };
    return (
      <div>
        <Row>
          <Col span={5}>
            <Link to="/finance/e_manage/add">
              <Button type="primary">申请报销</Button>
            </Link>
          </Col>
          <Col span={19}>
            <FormSearch
              onChange={this.handleChange}
              onSearch={this.handleSearch}
              {...this.searchCondition}
            />
          </Col>
        </Row>
        <div id="ant-small-table">
          <TableExpenses {...parentProps} />
        </div>
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
}))(Form.create({ wrappedComponentRef: true })(Manage));



// WEBPACK FOOTER //
// ./src/components/finance/expenses/PageMine.js